var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":"","fixed":true,"border":true},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"replay","size":"18"},on:{"click":_vm.refresh}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }